import React, { useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { observer } from 'mobx-react';
import { Button } from '@mui/material';
import { styled } from '@mui/system';
import { isEmpty } from 'lodash';
import SettingModel from '../setting-company-model';

import '../scss/rival.scss';
import Color from '@tool/color';
import { CloseIcon20 } from '@styled/icon';
import { newRate } from '@tool/index';
import moRival, { initRival } from '../store/rival';
import Title from '../../styled/title';
import Recruitment from './component/recruitment';
import CustomReport from './component/custom-report';
import moChange from '../store/change';
import getShowModule from '../store/common';
import BannerGroup from '../industry/component/banner-group';

interface IProps {}
interface IState {}

const Rival = (props: IProps, state: IState) => {
  const navi = useNavigate();
  const { modelList } = moChange;

  useEffect(() => {
    return () => {};
  }, []);

  return (
    <section className="content-0011 dash-rival-warp">
      {(
        getShowModule('rival', '对标企业招聘动态', modelList) ||
      getShowModule('rival', '定制薪酬报告', modelList) ||
      getShowModule('rival', '广告位', modelList)
      ) &&
      <section className="title"><Title text="竞品企业数据" /></section>}
      {getShowModule('rival', '对标企业招聘动态', modelList) && <Recruitment />}
      {getShowModule('rival', '定制薪酬报告', modelList) && <CustomReport />}
      {getShowModule('rival', '广告位', modelList) && <BannerGroup />}
      <SettingModel/>
    </section>
  );
};

export default observer(Rival);
